export const u2kFilters: ({ short: string, value: string })[] = [
  { short: "HSC-G", value: "HSC-G" },
  { short: "HSC-I", value: "HSC-I" },
  { short: "HSC-R", value: "HSC-R" },
  { short: "HSC-Y", value: "HSC-Y" },
  { short: "HSC-Z", value: "HSC-Z" },
  { short: "IB0945", value: "IB0945" },
  { short: "MegaCam-u", value: "MegaCam-u" },
  { short: "MegaCam-uS", value: "MegaCam-uS" },
  { short: "NB0387", value: "NB0387" },
  { short: "NB0527", value: "NB0527" },
  { short: "NB0718", value: "NB0718" },
  { short: "NB0816", value: "NB0816" },
  { short: "NB0921", value: "NB0921" },
  { short: "NB0926", value: "NB0926" },
  { short: "NB0973", value: "NB0973" },
  { short: "NB1010", value: "NB1010" },
  { short: "VIRCAM-H", value: "VIRCAM-H" },
  { short: "VIRCAM-J", value: "VIRCAM-J" },
  { short: "VIRCAM-Ks", value: "VIRCAM-Ks" },
  { short: "VIRCAM-NB118", value: "VIRCAM-NB118" },
  { short: "VIRCAM-Y", value: "VIRCAM-Y" },
  { short: "WFCAM-H", value: "WFCAM-H" },
  { short: "WFCAM-J", value: "WFCAM-J" },
  { short: "WFCAM-K", value: "WFCAM-K" },
]


// u (Megacam), grizy, N387, N816, N921 (HSC), JHK (WFCAM) 
export const u2kV2Filters: ({ short: string, value: string })[] = [
  { short: "HSC-G", value: "HSC-G" },
  { short: "HSC-I", value: "HSC-I" },
  { short: "HSC-R", value: "HSC-R" },
  { short: "HSC-Y", value: "HSC-Y" },
  { short: "HSC-Z", value: "HSC-Z" },
  // { short: "IB0945", value: "IB0945" },
  { short: "MegaCam-u", value: "MegaCam-u" },
  // { short: "MegaCam-uS", value: "MegaCam-uS" },
  { short: "NB0387", value: "NB0387" },
  // { short: "NB0527", value: "NB0527" },
  // { short: "NB0718", value: "NB0718" },
  { short: "NB0816", value: "NB0816" },
  { short: "NB0921", value: "NB0921" },
  // { short: "NB0926", value: "NB0926" },
  // { short: "NB0973", value: "NB0973" },
  // { short: "NB1010", value: "NB1010" },
  // { short: "VIRCAM-H", value: "VIRCAM-H" },
  // { short: "VIRCAM-J", value: "VIRCAM-J" },
  // { short: "VIRCAM-Ks", value: "VIRCAM-Ks" },
  // { short: "VIRCAM-NB118", value: "VIRCAM-NB118" },
  // { short: "VIRCAM-Y", value: "VIRCAM-Y" },
  { short: "WFCAM-H", value: "WFCAM-H" },
  { short: "WFCAM-J", value: "WFCAM-J" },
  { short: "WFCAM-K", value: "WFCAM-K" },
]
